import { ChangeEvent } from 'react';

import { Beneficiary } from '../../../../models/payouts';
import DropdownBanks from '../dropdownBanks';
import {
	Divider,
	HintInput,
	InputContainer,
	ResumeContainer,
	SelectAndInputContainer,
} from '../editModal/styles';
import { Input } from '../input/index';
import OutboundResume from '../outboundResume';
import { Options, paymentTypeOptions } from '.';

interface ContentModalProps {
	steps: number;
	beneficiarySelected: Beneficiary;
	setBeneficiarySelected: (
		beneficiary: Beneficiary | ((prevState: Beneficiary) => Beneficiary),
	) => void;
	handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
	handleClearInput: () => void;
}

interface TransferResumeItem {
	item: string;
	data: string;
}

const ContentModal = ({
	steps,
	beneficiarySelected,
	setBeneficiarySelected,
	handleChangeInput,
	handleClearInput,
}: ContentModalProps) => {
	const userResume: TransferResumeItem[] = [
		{
			item: 'RUT',
			data: beneficiarySelected.rut,
		},
		{
			item: 'Nombre beneficiario',
			data: beneficiarySelected.name,
		},
		{
			item: 'Correo beneficiario',
			data: beneficiarySelected.email,
		},
	];

	const bankResume: TransferResumeItem[] = [
		{
			item: 'Banco',
			data: beneficiarySelected.bankName,
		},
		{
			item: 'Número de cuenta',
			data: beneficiarySelected.account,
		},
	];

	if (steps == 1) {
		return (
			<>
				<InputContainer>
					<Input
						label="RUT"
						name="rut"
						variant="large"
						value={beneficiarySelected.rut}
						disabled
						fontSize="16px"
					/>
					<Input
						label="Nombre del beneficiario (máx. 40 caracteres)"
						name="name"
						variant="large"
						value={beneficiarySelected.name}
						onChange={handleChangeInput}
						placeholder="Juan Perez"
						fontSize="16px"
					/>
					<div>
						<Input
							label="Correo electrónico del beneficiario"
							name="email"
							variant="large"
							value={beneficiarySelected.email}
							onChange={handleChangeInput}
							placeholder="juanperez@correo.com"
							fontSize="16px"
						/>
						<HintInput>Lo usaremos para notificar la confirmación de pago</HintInput>
					</div>
					<Divider />
					<SelectAndInputContainer>
						<DropdownBanks
							options={paymentTypeOptions}
							state={beneficiarySelected.bankName}
							onChange={(bank: Options) =>
								setBeneficiarySelected((prevState: Beneficiary) => ({
									...prevState,
									bankName: bank.label,
									bankSbifNumber: bank.value,
								}))
							}
							clearState={handleClearInput}
						/>
						<Input
							label="Número de cuenta"
							name="account"
							variant="large"
							value={beneficiarySelected.account}
							onChange={handleChangeInput}
							placeholder="0000.0000.0000.0000"
							fontSize="16px"
						/>
					</SelectAndInputContainer>
				</InputContainer>
			</>
		);
	} else {
		return (
			<>
				<ResumeContainer>
					<OutboundResume transferResume={userResume} />
					<OutboundResume transferResume={bankResume} />
				</ResumeContainer>
			</>
		);
	}
};

export default ContentModal;
